export const CATALOG_ITEMS_PER_PAGE = 60;

export const LIST_ITEMS_PER_PAGE = 15;
